export default __webpack_public_path__ + "a7be5678af18f53b6fc10324991ce945.png";